import ResourcesDispatcher from "../../config/ResourcesDispatcher";
import Utils from "../../utils/Utils";
import Reel from "./Reel";

export default class ReelStatic extends Reel {
    constructor(scene: any, x: number, y: number, index: number, orientation: any, expanding: boolean) {
        super(scene, x, y, index, orientation, expanding);
    }

    public createReelMask(orientation: any): void {
        // se esiste già una graphics/mask precedente la distruggiamo e rimuoviamo la mask dal container
        if (this.reelMask) {
            this.reelMask.destroy();
            this.container.clearMask(true);
            this.reelMask = undefined as any;
        }

        const visibleHeight = this.cellSize.height * this.numOfCellsPerReel;
        const currentOrientation = orientation;

        let xContainer = 0;
        let yContainer = 0;
        let scale = 0;

        if(currentOrientation == "portrait") {
            xContainer = this.container.x + ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.PORTRAIT_X; //155
            yContainer = this.container.y + ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.PORTRAIT_Y; //796
            scale = ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.PORTRAIT_SCALE;
        }
        else{
            xContainer = this.container.x + ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.LANDSCAPE_X; //525
            yContainer = this.container.y + ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.LANDSCAPE_Y; //280
            scale = ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.LANDSCAPE_SCALE;
        }

        // crea la graphics che useremo per la mask (la aggiungiamo alla scena per poterla gestire/distruggere facilmente)
        this.reelMask = this.scene.make.graphics({ x: 0, y: 0, add: false });
        this.reelMask.fillRect(xContainer, yContainer, ResourcesDispatcher.GAME_CONSTANTS.REEL_STATIC_MASK_WIDTHS[this.index], visibleHeight).setScale(scale);

        // Serve per mostrare la maschera della griglia per debuggare
        // const debugGraphics = this.scene.add.graphics();
        // debugGraphics.lineStyle(2, 0xff0000, 1); // spessore 2px, rosso

        // this.cells.forEach((cell) => {
        //     const c = cell.getContainer(); // container grafico della cella
        //     const width = this.cellSize.width;
        //     const height = visibleHeight;

        //     debugGraphics.strokeRect(xContainer, yContainer, width, height).setScale(scale);
        // });

        // // crea la maschera
        this.container.setMask(new Phaser.Display.Masks.GeometryMask(this.scene, this.reelMask));
    }

    public configureSpinTween() {
        this.resetFlagsAndCounters();
        
        this.spinProgress = this.scene.tweens.add({
            targets: this.spinProgressValue,
            ease: "Linear",
            value: { from: 0, to: this.cellSize.height},
            paused: true,
            loop: -1,
            delay: 0,
            yoyo: false,
            duration: this.spinAnimationDuration,
            onStart: () => {
                this.expandingWild?.getContainer().setVisible(false);

                this.getCells().forEach(cell => {
                    cell.resetLayer();
                    cell.stopAnimation();
                });

                this.turnOn();
            },
            onUpdate: () => {
                if (this.stopped) {
                    return;
                }

                this.getCells().forEach(cell => {
                    cell.getContainer().y = this.cellPosition[cell.getIndex()].y + this.spinProgressValue.value;

                    // ON/OFF depending on memo if suspense is on
                    if (this.suspense && this.suspenseStarted) {
                        if (Utils.includes(ResourcesDispatcher.GAME_CONSTANTS.onDuringSuspense, cell.getMemo())) {
                            cell.turnOn();
                        } else {
                            cell.turnOff();
                        }
                    }
                });
                
            },
            onLoop: () => {
                if (this.stopped) {
                    return;
                }

                this.virtualReelPosition = (this.virtualReelPosition + 1) % this.scene.gameArea.virtualGrid[this.index].length;
                this.scene.gameArea.increaseLoopCounter(this.index);

                this.reIndexCells();
                if (this.mustStop) {

                    this.getCell(this.lastCellIndex).setCellInfo(this.gameDataManager.getOutGridCellsUp()[this.index]);
                    this.getCell(0).setCellInfo(this.gameDataManager.getOutGridCellsDown()[this.index]);

                    // Real memo
                    for (let i = 1; i < this.lastCellIndex; i++) {
                        const realmemo = this.gameDataManager.getGrid()[this.index * this.numOfCellsPerReel + (i - 1)];
                        let gridListIndex = Utils.getCellGridIndex(this.index, i, this.numOfCellsPerReel, this.numOfExtraCellsPerReel);
                        this.getCell(i).setCellInfo(realmemo, undefined, gridListIndex ? this.gameDataManager.getLinkGrid()[gridListIndex] : undefined);
                    }

                    this.spinProgress.stop();
                    this.bounce();

                } else if (!this.canStop) { // Fake memo
                    const xmemo = this.scene.gameArea.virtualGrid[this.index][this.virtualReelPosition];
                    this.getCell(this.lastCellIndex).setCellInfo(xmemo);

                } else if (this.canStop) {
                    if (this.realMemoIndex === 0) { // Invisible cell
                        this.getCell(this.lastCellIndex).setCellInfo(this.gameDataManager.getOutGridCellsDown()[this.index]);
                    } else if (this.realMemoIndex < this.lastCellIndex) { // Visible cell, real memo
                        const realmemo = this.gameDataManager.getGrid()[this.index * this.numOfCellsPerReel + (this.realMemoIndex - 1)];
                        this.getCell(this.lastCellIndex).setCellInfo(realmemo, undefined, this.gameDataManager.getLinkGrid()[this.index * this.numOfCellsPerReel + (this.realMemoIndex - 1)] ?? undefined);
                    } else if (this.realMemoIndex === this.lastCellIndex) { // Invisible cell, fake memo with SCATTER and WILD check, stop spin
                        this.getCell(this.lastCellIndex).setCellInfo(this.gameDataManager.getOutGridCellsUp()[this.index]);
                        this.spinProgress.stop();
                        this.bounce();
                    }
                    this.realMemoIndex++;
                }
            }
        });
    }

    public bounce() {
        if (this.stopped) {
            return;
        }

        this.bounceTween1 = this.scene.tweens.add({
            targets: this.spinProgressValue,
            ease: "Linear",
            value: { from: 0, to: this.cellSize.height * 0.75 },
            yoyo: false,
            duration: this.spinAnimationDuration * 0.75,
            onStart: () => {
                this.stopped = true;
            },
            onUpdate: () => {
                this.getCells().forEach((cell) => {
                    // Position
                    cell.getContainer().y = this.cellPosition[cell.getIndex()].y + this.spinProgressValue.value;
                });
            },
            onComplete: () => {
                this.scene.soundManager.play(ResourcesDispatcher.SOUNDS.SOUND_REELS_STOP);

                if (!this.gameLogicVariableManager.getTurbo()) {

                    for(let i=0; i<this.lastCellIndex; i++){
                        const currentCell = this.getCell(i)
                        if(!currentCell) continue;

                        const memo = currentCell.getMemo();

                        if(ResourcesDispatcher.GAME_CONSTANTS.ANIMATED_SYMBOLS.includes(memo)){
                            this.playAnimationBounceSingleCell(currentCell, memo);
                        }
                    }

                    // Scatter sound
                    if (this.gameDataManager.getScatterInfo().length > 0) {

                        const scatter: boolean = (this.gameDataManager.getScatterInfo().filter((info:any) => info.reelIndex === this.index).length !== 0);
                        const minNumScatter: number = (this.gameLogicVariableManager.getCurrentGameMode() === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.FREEGAME ? 2 : 3);
                        const previousReelsWithScatter: number = this.gameDataManager.getScatterInfo().filter((info : any) => info.reelIndex < this.index).length;
                        const residualScattersToWin: number = minNumScatter - previousReelsWithScatter - (scatter ? 1 : 0); // -1 because this reeel contains a scatter
                        const residualReels: number =  this.numOfReels - 1 - this.index;

                        if (
                            (scatter && !this.mustStop && residualScattersToWin <= 0) ||                // CONDITION 1: scatter in reel, no forced stop, freegame already won
                            (scatter && !this.mustStop && residualScattersToWin <= residualReels) ||    // CONDITION 2: scatter in reel, no forced stop, freegame can still be won
                            (this.mustStop && residualReels === 0 && residualScattersToWin === 0)       // CONDITION 3: forced stop, last reel and freegame already won
                        ) {
                            //TODO Mettere questa riga e sostituire con this.soundscatterinreel con sound
                            this.scene.soundManager.getSoundGame().play(this.soundScatterInReel.key, { loop: this.soundScatterInReel.loop, volume: this.soundScatterInReel.volume });
                        }
                    }
                }

                // Turbo on(low volume) or forced stop
                if (this.gameLogicVariableManager.getTurbo() || this.mustStop) {
                    // TODO: add stop sound
                }

                this.bounceTween2 = this.scene.tweens.add({
                    targets: this.spinProgressValue,
                    ease: "Power0",
                    value: { from: this.cellSize.height * 0.75, to: 0 },
                    yoyo: false,
                    duration: this.spinAnimationDuration * 6,     
                    //TODO implementare ONSTART
                    onStart: () => {
                        // play landing animation 
                        this.cells.forEach((cell, cellIndex) => {
                            if (cellIndex > 0 && cellIndex < ResourcesDispatcher.GAME_CONSTANTS.LAST_CELL_INDEX) {
                                switch (cell.getMemo()) {
                                    case ResourcesDispatcher.GAME_CONSTANTS.S_LINK:
                                    case ResourcesDispatcher.GAME_CONSTANTS.S_MINI:
                                    case ResourcesDispatcher.GAME_CONSTANTS.S_MINOR:
                                    case ResourcesDispatcher.GAME_CONSTANTS.S_MAJOR:
                                    case ResourcesDispatcher.GAME_CONSTANTS.S_GRAND:
                                        cell.playLandingAnimation();
                                        break;
                                    default:
                                        break;
                                }
                            }
                        });
                    },
                    onUpdate: () => {
                        this.getCells().forEach((cell) => {
                            // Position
                            cell.getContainer().y = this.cellPosition[cell.getIndex()].y + this.spinProgressValue.value;
                        });
                    },
                    onComplete: () => {
                        this.getCells().forEach((cell) => {
                            cell.checkLayer();
                        });

                        this.scene.time.addEvent({
                            delay: 150,
                            callback: () => {
                                this.scene.gameArea.notifySpinCompleted(this.index);
                            },
                        });

                        this.manageSuspense();
                    }
                });
            }
        });
    }
}
